module.exports = __webpack_public_path__ + "img/logo-lyon-2.ab3e66ac.png";